import * as React from "react";
import { FieldValueMedia } from "typings/index";
import { Dialog, Nav, DialogType, PrimaryButton, DialogFooter, DefaultButton } from "office-ui-fabric-react/lib";
import { BaseFieldEditor } from "../helper";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { getMediaByType, getAllMediaItems, getMultipleMedia } from "~/state/action";
import { folderToNavLink } from "~/components/media/helper";
import { loadMedia, loadMultipleMedia } from "~/state/media/action";
import ListMediaFiles, { mediaItemRender } from "~/components/media/ListMediaFiles";
import styled from "styled-components";

export interface Props extends BaseFieldEditor
{
    value: FieldValueMedia;
    placeholder?: string;
}

interface State
{
    showMediaPickerDialog: boolean;
    folderId: string;
    selectedItems: string[];
}
const DialogStyle = styled.div`
    display:flex;
    .ms-Dialog-content{
       
    }
    .ms-Nav-navItems {
        margin:6px;
    }
    .ms-List-page{
        grid-template-columns: 115px 115px 115px 115px;
        grid-gap: 28px;
        display: grid;
    }
    .item
    {
        cursor: pointer;
        display: block;
        width: 80px;
        height: 85px;
        margin: 5px;
        text-align: center;
        background-color: #f4f4f4;
        padding: 15px;
        position: relative;
        &.selected{
            background-color: lightgray;
        }
        h5{
            position: absolute;
            top: 77px;
            text-align: center;
            width: 92%;
            left: 0px;
            font-size: 12px;
            font-weight: 400;
            height: 33px;
            overflow: hidden;
            margin: 0px 5px;
        }
        i{
            font-size: 62px;
            color: deepskyblue;
        }
        &.image
        {
            img{
                max-height:61px;
                max-width: 80px;
            }
        }
           
    }
`;

const  MediaList = styled.div`
    grid-template-columns: 150px 150px 150px 150px;
    grid-gap: 28px;
    display: grid;
    clear: both;
    > button{
        height: 150px;
        background: transparent;
        border: dashed 1px;
    }
`;

const MediaItem  = styled.div`
    position: relative;
    img{
        max-width: 150px;
        max-height: 150px;
    }
    .ms-Button{
        position: absolute;
        top: 0px;
        right: 0px;
        border: 0px;
        min-width: 32px;
        padding: 0px;
        border-radius: 50px;
        background: white;
        font-size: 10px;
        min-height: 0px;
        margin: 3px;
    }
`;

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    const value =  ownProps.value && ownProps.value.value ? ownProps.value.value : undefined;
    const media = value ? getMultipleMedia(state, value) : [];
    return {
        folders: getMediaByType(state, "folder"),
        files: getAllMediaItems(state),
        media
    };
}; 

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadMedia: (id: string) => dispatch(loadMedia(id)),
    loadMultipleMedia: (ids: string []) => dispatch(loadMultipleMedia(ids)),
});

export class Media extends React.Component<Props & StateProps, Partial<State>>
{
    state = {
        showMediaPickerDialog: false,
        folderId: undefined,
        selectedItems: this.props.value ? this.props.value.value || [] : []
    };

    componentWillMount = () =>
    {
        if (this.props.value && this.props.value.value)
        {
            this.props.loadMultipleMedia(this.props.value.value);
        }
    }

    onLinkClick = (id: string) => (e: React.MouseEvent<HTMLElement>) =>
    {
        e.preventDefault();
        this.props.loadMedia(id);
        this.setState({ folderId: id });
        return false;
    }

    toggleMediaPickerDialog = () => this.setState({ showMediaPickerDialog: !this.state.showMediaPickerDialog });

    onItemClick = (type: string, id: string) => () =>
    {
        if (type === "folder")
        {
            this.props.loadMedia(id);
            this.setState({ folderId: id });
        }
        else
        {
            const selectedItems = this.state.selectedItems;
            const item = selectedItems.find(x => x === id);
            const items = item ? selectedItems.filter(x => x !== id ) : [...selectedItems, id];
            this.setState({ selectedItems: items });
        }
    }

    onSave = (selectedItems = this.state.selectedItems) => () =>
    {
        const fieldValue: FieldValueMedia = { ...this.props.value, value: selectedItems };
        this.props.onValueChange(fieldValue);
        this.setState({ showMediaPickerDialog: false });
    }

    dialog = () =>
    {
        if (this.state.showMediaPickerDialog)
        {
            const { links } = folderToNavLink(this.props.folders, this.onLinkClick, this.state.folderId, null);
            const files = this.props.files.filter(x => x.parentId === this.state.folderId);
            return (
                <Dialog onDismiss={this.toggleMediaPickerDialog} hidden={false}
                    minWidth={730}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: "Media Picker",
                    }}>
                    <DialogStyle>
                        <Nav className="media-navigation" groups={[{links}]} /> 
                        <ListMediaFiles
                            files={files}
                            onItemClick={this.onItemClick}
                            selected={this.state.selectedItems}
                            />
                    </DialogStyle>
                    <DialogFooter>
                        <PrimaryButton onClick={this.onSave()} text="Save" />
                        <DefaultButton onClick={this.toggleMediaPickerDialog} text="Cancel" />
                    </DialogFooter>
                </Dialog>
            );
        }
    }

    onItemDelete = (id: string) => () =>
    {
        const items = this.state.selectedItems.filter(x => x !== id);
        this.onSave(items)();
        this.setState({ selectedItems: items });
    }

    renderMedia = () =>
    {
        return this.props.media.map((media, index) =>
        {
           return <MediaItem key={index}>
               <DefaultButton onClick={this.onItemDelete(media.id)} iconProps={{iconName: "Delete"}}></DefaultButton>
               {mediaItemRender(media, undefined, undefined, true)}
           </MediaItem> ;
        });
    }

    render()
    {
        return (
            <div>
                <MediaList>
                    {this.renderMedia()}
                    {(this.props.field.max !== 0 && this.props.media.length === this.props.field.max) ? ("") :
                        (<DefaultButton
                            disabled={this.props.disabled }
                            iconProps={{ iconName: "Add" }}
                            onClick={this.toggleMediaPickerDialog}
                        />)
                    }
                </MediaList>
                {this.dialog()}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Media);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/mediaPicker/Media.tsx